import { render, staticRenderFns } from "./PositionsList.vue?vue&type=template&id=81cde702&scoped=true"
import script from "./PositionsList.vue?vue&type=script&lang=js"
export * from "./PositionsList.vue?vue&type=script&lang=js"
import style0 from "./PositionsList.vue?vue&type=style&index=0&id=81cde702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cde702",
  null
  
)

export default component.exports